export class SkuPriceItemDto {
  skuId: number;
  price: number;
  effectiveFrom?: string | Date;
}

export class SkuPriceCreateRequestDto {
  items: SkuPriceItemDto[];
  effectiveFrom: string | Date;
  createdUser: string;
}

export class SkuPriceByDateRequestDto {
  skuId: number;
  date: string | Date;
}

export class SkuPriceHistoryRequestDto {
  skuId?: number;
  fromDate?: string | Date;
  toDate?: string | Date;
}

export class SkuPriceCurrentDto {
  skuId: number;
  skuName: string;
  price: number;
  effectiveFrom: string | Date;
}

export class SkuPriceHistoryDto {
  skuId: number;
  skuName: string;
  price: number;
  effectiveFrom: string | Date;
  effectiveTo?: string | null;
  isCurrent?: boolean;
}

export class SkuPriceByDateResultDto {
  skuId: number;
  skuName?: string;
  price: number;
  effectiveFrom: string | Date;
}

export class SkuMaxEffectiveDateRequestDto {
  skuId: number;
}
